import Head from 'next/head'
import striptags from 'striptags'

import { DEFAULT_OG_IMAGE, getAbsoluteImageUrl, getCanonicalUrl } from 'lib/seo'

export default function MetaTags({
  title = '24 FIX | บริการซ่อมแซมที่อยู่อาศัย มือช่างที่คุณวางใจ ที่เดียวจบ ครบทุกเรื่องซ่อม',
  description = '24 FIX | บริการซ่อมแซมที่อยู่อาศัย มือช่างที่คุณวางใจ ที่เดียวจบ ครบทุกเรื่องซ่อม',
  keywords = '24Fix, บริการซ่อมแซมที่อยู่อาศัย, ครบทุกเรื่องซ่อม',
  image = DEFAULT_OG_IMAGE,
  pathUrl,
  ogType = 'website',
  publishedTime,
  modifiedTime,
  expirationTime,
  author,
  section,
  tag,
  noIndex = false,
  imageAlt,
  structuredData,
}) {
  const normalizedTitle = striptags(title).trim()
  const normalizedDescription = striptags(description).replace(/\s+/g, ' ').trim()
  const canonicalUrl = pathUrl ? getCanonicalUrl(pathUrl) : null
  const imageUrl = getAbsoluteImageUrl(image)
  const robots = noIndex
    ? 'noindex, nofollow'
    : 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  const jsonLd = structuredData
    ? JSON.stringify(structuredData).replace(/</g, '\\u003c')
    : null

  return (
    <Head>
      <title>{normalizedTitle}</title>
      <meta key="description" name="description" content={normalizedDescription} />
      <meta key="keywords" name="keywords" content={keywords} />
      <meta key="viewport" name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta key="robots" name="robots" content={robots} />
      <meta key="googlebot" name="googlebot" content={robots} />
      {canonicalUrl && <link key="canonical" rel="canonical" href={canonicalUrl} />}
      {canonicalUrl && <meta key="og:url" property="og:url" content={canonicalUrl} />}
      <meta key="og:type" property="og:type" content={ogType} />
      <meta key="og:site_name" property="og:site_name" content="24 FIX" />
      <meta key="og:locale" property="og:locale" content="th_TH" />
      <meta key="og:title" property="og:title" content={normalizedTitle} />
      <meta key="og:description" property="og:description" content={normalizedDescription} />
      <meta key="og:image" property="og:image" content={imageUrl} />
      <meta key="og:image:secure_url" property="og:image:secure_url" content={imageUrl} />
      <meta key="og:image:alt" property="og:image:alt" content={imageAlt || normalizedTitle} />
      {publishedTime && <meta property="article:published_time" content={publishedTime} />}
      {modifiedTime && <meta property="article:modified_time" content={modifiedTime} />}
      {expirationTime && <meta property="article:expiration_time" content={expirationTime} />}
      {author && <meta property="article:author" content={author} />}
      {section && <meta property="article:section" content={section} />}
      {tag && <meta property="article:tag" content={tag} />}

      <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
      <meta key="twitter:title" name="twitter:title" content={normalizedTitle} />
      <meta key="twitter:description" name="twitter:description" content={normalizedDescription} />
      <meta key="twitter:image" name="twitter:image" content={imageUrl} />
      <meta key="twitter:image:alt" name="twitter:image:alt" content={imageAlt || normalizedTitle} />

      {jsonLd && (
        <script
          key="structured-data"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLd }}
        />
      )}
    </Head>
  )
}
